<template>
    <b-row class="justify-content-between align-items-end mb-1">
      <b-col sm="12" lg="9">
        <!-- Filter tanggal -->
        <section class="d-flex flex-wrap align-items-end">
          <b-form-group :label="sum_date == 2 ? `Tanggal Awal` : 'Tanggal'" class="mr-2 mb-0">
            <b-form-input type="date" v-model="form.tgl_awal"></b-form-input>
          </b-form-group>
          <b-form-group v-if="sum_date == 2" label="Tanggal Akhir" class="mr-2 mb-0">
            <b-form-input type="date" v-model="form.tgl_akhir"></b-form-input>
          </b-form-group>
          <slot></slot>
        </section>
        <!-- / -->
      </b-col>
      <b-col sm="12" lg="3" class="d-flex justify-content-end align-items-end mt-1 mt-lg-0">
        <slot name="dropdown-item" :form="form">
          <b-dropdown
            v-if="type_export.length > 1"
            variant="outline-primary"
            text="Export"
            right
          >
            <b-dropdown-item href="#" @click.prevent="onExport('pdf')">Export ke PDF</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="onExport('excel')">Export ke Excel</b-dropdown-item>
          </b-dropdown>
          <b-button
            v-else
            variant="outline-primary"
            @click.prevent="onExport(type_export[0] || 'excel')"
          >
            Export
          </b-button>
        </slot>
      </b-col>
    </b-row>
</template>
<script>
import {BFormInput, BRow, BCol, BFormGroup, BDropdown, BDropdownItem, BButton} from 'bootstrap-vue'
export default {
    components: {
        BFormInput, BRow, BCol, BFormGroup, BDropdown, BDropdownItem, BButton
    },
    data: () => ({
      form: {
        tgl_awal: null,
        tgl_akhir: null
      }
    }),
    methods: {
      onExport(type_export) {
        let typ = type_export
        if(this.type_export.length == 1 && this.type_export[0] == 'excel') {
          typ = 'excel'
        }
        this.$emit('onExport', {
          tgl_awal: this.form.tgl_awal, 
          tgl_akhir: this.form.tgl_akhir, 
          type_export: typ}
        )
      }
    },
    props: {
        type_export: {
            type: Array,
            default: () => ['excel']
        },
        sum_date: {
            type: Number,
            default: () => 2
        }
    }
}
</script>
